import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Locale} from '../../../model/locale';
import {OperatorProgramsService} from '../../../services/operator-programs.service';
import {LocalesService} from '../../../services/locales.service';
import {BulkEditExcelService} from '../../../services/bulk-edit-excel.service';
import * as XLSX from 'xlsx';
import {factory} from '../../../shared/app-logging';
import {ToastrService} from 'ngx-toastr';
import {Product} from '../../../model/product';
import {TemplatesService} from '../../../services/templates.service';

const logger = factory.getLogger('TemplateBulkEditExportComponent');

@Component({
  selector: "app-template-bulk-edit-export",
  templateUrl: "./template-bulk-edit-export.component.html",
  styleUrls: ["./template-bulk-edit-export.component.scss"],
})
export class TemplateBulkEditExportComponent implements OnInit {
  @Input()
  locales: Locale[];
  @Input()
  localeSel: Locale;
  @Input()
  products: Product[];
  @Input()
  productSel: Product;
  @Output()
  productSelChange = new EventEmitter<Product>();
  @Output()
  localeSelChange = new EventEmitter<Locale>();
  exportingExcelFile: boolean;

  public getOperatorProgramProductDisplayLabel = TemplatesService.getOperatorProgramProductDisplayLabel;

  constructor(private operatorProgramsService: OperatorProgramsService,
              private localesService: LocalesService,
              private excelService: BulkEditExcelService,
              private toastr: ToastrService) {
  }

  ngOnInit() {
  }

  downloadBulkEditExcelVBAFile(): void {
    if (!this.localeSel) {
      return;
    }
    this.exportingExcelFile = true;
    this.excelService.exportExcelVBAFile(this.localeSel, this.productSel).subscribe(wb => {
      this.exportingExcelFile = false;
      const filename = 'Template-Bulk-Edit[' + this.localeSel.localeName + '][' +
        this.getOperatorProgramProductDisplayLabel(this.productSel) +
        '](' + (new Date()).toISOString() + ').xlsx';
        const wbXLSX = XLSX.read(wb, { type: 'array' });
      const wbNoMacros = XLSX.utils.book_new();
      wbXLSX.SheetNames.forEach(function(sheetName) {
          const ws = wb.Sheets[sheetName];
          XLSX.utils.book_append_sheet(wbNoMacros, ws, sheetName);
      });

      // Write the .xlsx file without macros
      XLSX.writeFile(wbNoMacros, filename);
      this.toastr.success(`The data was successfully exported into an Excel® file.`, `Success`);
    }, error => {
      this.exportingExcelFile = false;
      error.message = `While exporting excel file. ${error.message}`;
      throw error;
    });
  }
  downloadBulkEditExcelXLXS(): void {
    if (!this.localeSel) {
      return;
    }
    this.exportingExcelFile = true;
    this.excelService.exportExcelXLS(this.localeSel, this.productSel).subscribe(wb => {
      this.exportingExcelFile = false;
      const filename = 'Template-Bulk-Edit[' + this.localeSel.localeName + '][' +
        this.getOperatorProgramProductDisplayLabel(this.productSel) +
        '](' + (new Date()).toISOString() + ').xlsx';
        XLSX.writeFile(wb, filename);
      this.toastr.success(`The data was successfully exported into an Excel® file.`, `Success`);
    }, error => {
      this.exportingExcelFile = false;
      error.message = `While exporting excel file. ${error.message}`;
      throw error;
    });
  }
  checkSelection(): boolean {
    return this.products && this.products.length > 0 && this.localeSel && true;
  }

  setLocaleSel(target) {
    this.localeSel = target;
    this.localeSelChange.emit(this.localeSel);
  }

  setProgramSel(target) {
    this.productSel = target;
    this.productSelChange.emit(this.productSel);
  }
}
